import { ChartActions, ChartPermission, ErrorFormField } from 'components/common';
import { ELSFlex, ELSFlexItem } from 'components/common/els';
import { ChartViewProps } from 'components/features/shared/constants';
import { FormField, SectionTitle } from './constants';

const LaborInterventionsView = (props: ChartViewProps) => {
  const { chartActionsProps, formFieldMap, formSubmittedCount } = props;
  return (
    <div className="labor-interventions">
      <h1>{SectionTitle.LABOR_INTERVENTIONS}</h1>
      <ErrorFormField formField={formFieldMap.get(FormField.NO_CARE_REQUIRED)} formSubmittedCount={formSubmittedCount} />
      <ELSFlex className="u-flex-gutter-3x" left wrap>
        <ELSFlexItem w="1o2" md="1o1">
          <h2>{SectionTitle.LABOR_CARE}</h2>
          <ErrorFormField className="u-els-margin-top" formField={formFieldMap.get(FormField.LABOR_CARE)} formSubmittedCount={formSubmittedCount} />
        </ELSFlexItem>
        <ELSFlexItem w="1o2" md="1o1">
          <h2>{SectionTitle.DELIVERY_CARE}</h2>
          <ErrorFormField className="u-els-margin-top" formField={formFieldMap.get(FormField.DELIVERY_CARE)} formSubmittedCount={formSubmittedCount} />
        </ELSFlexItem>
        <ELSFlexItem w="1o2" md="1o1">
          <h2>{SectionTitle.PATIENT_RESPONSE}</h2>
          <ErrorFormField className="u-els-margin-top" formField={formFieldMap.get(FormField.PATIENT_RESPONSE)} formSubmittedCount={formSubmittedCount} />
        </ELSFlexItem>
      </ELSFlex>
      <ErrorFormField formField={formFieldMap.get(FormField.LABOR_CARE_NOTES)} formSubmittedCount={formSubmittedCount} />
      <ChartPermission>{({ allowSaveFragment }) => allowSaveFragment && <ChartActions {...chartActionsProps} />}</ChartPermission>
    </div>
  );
};

LaborInterventionsView.displayName = 'LaborInterventionsView';
export default LaborInterventionsView;
